import React from 'react';

// Fonctions utilise lors de la qualification

// Construit l'arbre des composants a partir d'un descripteur.
// - components : tableau plat des elements React (ordre de rendu)
// - node       : noeud de trace decrivant la structure reellement parcourue
function buildComponents(descriptor, components, node) {

    // On s'assure d'avoir un tableau
    let descriptors = [];
    if (Array.isArray(descriptor)) {
        descriptors = descriptor;
    }
    else {
        descriptors.push(descriptor);
    }

    // Pour chaque element du tableau on retourne l'arbre des composants
    descriptors.forEach(component => {

        let childNode = {
            name: component.name,
            rendered: false,
            value: undefined,
            hasValue: false,
            children: []
        };
        node.children.push(childNode);

        if (component.renderer) {
            let Renderer = component.renderer;

            // On rajoute le composant
            components.push(<Renderer key={components.length} name={component.name} />);
            childNode.rendered = true;
        }

        // S'il y a un getter et des sous-composants, par recursion, on ajoute les sous-composants
        if (component.getter instanceof Function) {
            let value = component.getter();
            childNode.value = value;
            childNode.hasValue = true;

            component.subComponents.forEach(subComponent => {

                if (subComponent.tester === undefined) {
                    let branch = {
                        name: subComponent.name,
                        branch: 'sans tester',
                        kept: true,
                        children: []
                    };
                    childNode.children.push(branch);
                    buildComponents(subComponent.descriptor, components, branch);
                }
                else if (subComponent.tester instanceof Function) {
                    let kept = subComponent.tester(value);
                    let branch = {
                        name: subComponent.name,
                        branch: 'tester',
                        kept: kept,
                        testedValue: value,
                        children: []
                    };
                    childNode.children.push(branch);

                    if (kept) {
                        buildComponents(subComponent.descriptor, components, branch);
                    }
                }
                else {
                    childNode.children.push({
                        name: subComponent.name,
                        branch: 'tester invalide',
                        kept: false,
                        error: 'subComponent.tester is not a function',
                        children: []
                    });
                }
            });
        }
    });

    return components;
}

// Rend un noeud de trace sous forme de lignes indentees facon `tree`
function formatTree(node, prefix, isLast, lines) {

    if (prefix === undefined) {
        // Racine : on n'affiche que les enfants
        node.children.forEach((child, index) => {
            formatTree(child, '', index === node.children.length - 1, lines);
        });
        return lines;
    }

    let connector = isLast ? '└─ ' : '├─ ';
    let label = node.name || '(sans nom)';
    let details = [];

    if (node.branch === 'tester') {
        details.push(node.kept
            ? 'acceptee: ' + JSON.stringify(node.testedValue)
            : 'REJETEE: ' + JSON.stringify(node.testedValue));
    }
    else if (node.branch === 'sans tester') {
        details.push('sans tester');
    }
    else if (node.branch === 'tester invalide') {
        details.push('ERREUR: ' + node.error);
    }

    if (node.rendered) {
        details.push('rendu');
    }
    if (node.hasValue) {
        details.push('valeur: ' + JSON.stringify(node.value));
    }

    lines.push(prefix + connector + label + (details.length ? '  [' + details.join(' | ') + ']' : ''));

    let childPrefix = prefix + (isLast ? '   ' : '│  ');
    node.children.forEach((child, index) => {
        formatTree(child, childPrefix, index === node.children.length - 1, lines);
    });

    return lines;
}

// Point d'entree historique : ne retourne que les composants
function getComponents(descriptor) {
    let root = { name: 'root', children: [] };
    return buildComponents(descriptor, [], root);
}

// Point d'entree avec trace : { components, tree, logTree }
function getComponentsWithTrace(descriptor) {
    let root = { name: 'root', children: [] };
    let components = buildComponents(descriptor, [], root);

    return {
        components: components,
        tree: root,
        logTree: (title) => {
            let lines = formatTree(root, undefined, true, []);
            console.log((title || 'Structure de qualification')
                + ' (' + components.length + ' composant(s))' + '\n'
                + lines.join('\n'));
        }
    };
}


export default {

    // Obtention des errors depuis une liste de valeur et une liste de règles

    getErrors : (toCheck, rules) => {

        // console.log("toCheck", toCheck);
        // console.log("rules", rules);

        let errors = [];

        rules.forEach(rule => {
            let check = false;

            if (Array.isArray(rule.fields)) {
                // Traitement pour plusieurs champs
                let valuesToCheck = rule.fields.map(field => toCheck[field]);
                check = rule.assertion(valuesToCheck);
            }
            else {
                // Traitement pour un seul champ
                let valueToCheck = toCheck[rule.fields];
                check = rule.assertion(valueToCheck);
            }


            if (!check) {
                errors.push({ key: rule.key, errorMsg: rule.errorMsg });
            } else {
                errors.push({ key: rule.key, errorMsg: null });
            }

        });

        // console.log("errors", errors);

        return errors;
    },

    getComponents: getComponents,

    getComponentsWithTrace: getComponentsWithTrace
}



// Exemple de descripteur : 


//descriptor = [
//    {
//        name: 'not required',
//        renderer: this.renderAchatInitialFoussier, // required
//        getter: this.getAchatInitialFoussier, // not required
//        subComponents: [ // not required
//            { tester: a => a, descriptor: this.achatInitialFoussierDescriptor },              // tester return true or false, if true, recursion is done on the subCompenent descriptor
//            { tester: a => a === false, descriptor: this.nonAchatInitialFoussierDescriptor }
//        ]
//    },
//    {
//        // Another component
//    }
//];
